
import { useExportShipmentDetails } from './Hook/useExportShipmentDetails';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from "../../common/CustomModal";
import { DELETE_IMPORT_PLANNING_BUDGET, LIST_COMMERCIAL_INVOICES_EXPORT, LIST_IMPORT_PLANNING_BUDGETS, LIST_PROFORMA_INVOICES_EXPORT } from '../../../services/apiRoutes';
import { genericPost } from '../../../services/authServices';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import { getCurrencyList, getCommanExportShipmentId, } from '../../../services/CommonServices';
import CustomLoader from "../../common/CustomLoader";
import { AuthContext } from "../../../context/AuthContext";
import BookOnlineOutlinedIcon from '@mui/icons-material/BookOnlineOutlined';
import CustomStatus from "../../common/CustomStatus";
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";
import CreatePlanningBudgetExport from "../CreateForm/CreatePlanningBudgetExport";
import UpdatePlanningBudgetExport from "../UpdateForm/UpdatePlanningBudgetExport";
import PlanningBudgetExportView from "../ViewDetails/PlanningBudgetExportView";


export default function PlanningBudgetExport({ fetchButtonList }) {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();
    const [open, setOpen] = useState(true);
    const [leadModal, setLeadModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    });
    const [planningBudgetId, setplanningBudgetId] = useState('');
    const [viewModal, setViewModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('planningBudgetExport');
    const [currencyList, setCurrencyList] = useState([]);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')
    const [proformaInvoiceList, setProformaInvoiceList] = useState([]);
    const [commercialInvoiceList, setCommercialInvoiceList] = useState([]);

    const navigate = useNavigate();
    const { exportShipmentId } = useParams();
    const { shipmentDetails, loading: shipmentLoading } = useExportShipmentDetails(exportShipmentId);
    let customerId, cifFob;
    const hasFetched = useRef(false);

    useEffect(() => {
        if (shipmentDetails) {
            customerId = shipmentDetails.customerId;
            cifFob = shipmentDetails.cifFob.cifFobName;
            fetchData();
            getCommonData();
            getProformaInvoice();
            getCommercialInvoice();
            hasFetched.current = true;
        }
    }, [shipmentDetails, updateModal, planningBudgetId, token, deleteAlert, leadModal]);


    const getProformaInvoice = async () => {
        try {
            const payload = {
                customerNamesId: customerId,
                shipmentId: shipmentId
            };

            const response = await genericPost(LIST_PROFORMA_INVOICES_EXPORT, payload);

            if (response.data && response.data.success && response.data.data) {
                const proform = response.data.data.map((invoice) => {
                    // ✅ Calculate total qty from all particulars
                    const totalQty = invoice.particulars?.reduce((sum, item) => {
                        return sum + Number(item.qty || 0);
                    }, 0);

                    return {
                        id: invoice.proformaInvExpId || '',
                        title: invoice.proformaInvoiceNo || '',
                        totalQty: totalQty,
                    };
                });

                setProformaInvoiceList(proform);
            } else {
                setProformaInvoiceList([]);
            }
        } catch (error) {
            console.error('Error fetching proforma invoices:', error);
            setProformaInvoiceList([]);
        }
    };

    const getCommercialInvoice = async () => {
        try {
            const payload = {
                customerNamesId: customerName,
                shipmentId: shipmentId,
            };
            const response = await genericPost(LIST_COMMERCIAL_INVOICES_EXPORT, payload, {
            });
            if (response.data && response.data.success) {
                const invoices = response.data.data.map((invoice) => ({
                    id: invoice.commercialInvExpId,
                    title: invoice.commercialInvoiceNo,
                }));
                setCommercialInvoiceList(invoices);
            } else {
                console.error("No data available");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const formatPortName = (port, country) => {
        return [port, country].filter(Boolean).join(", ");
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                clientCompanyId: customerId,
                commanShipmentId: getCommanExportShipmentId,
                shipmentId: shipmentId,
            };
            const response = await genericPost(LIST_IMPORT_PLANNING_BUDGETS, payload, {
            });

            if (response.data.success && response.data.planningBudget) {
                const planningBudgetData = response.data.planningBudget.map((budget, index) => ({
                    index: (index + 1).toString().padStart(2, '0'),
                    planningBudgetId: budget.planningBudgetId,
                    userId: budget.userId,
                    companyId: budget.companyId,
                    commanShipmentId: budget.commanShipmentId,
                    clientCompanyId: budget.clientCompanyId,
                    shipmentId: budget.shipmentId,
                    currencyId: budget.currencyId,
                    baseCurrencyId: budget.baseCurrencyId,
                    shipmentOrgId: budget.shipmentOrgId,
                    proformaInvoiceId: budget.proformaInvoiceId,
                    proformaInvExpId: budget.proformaInvExpId,
                    commercialInvExpId: budget.commercialInvExpId,
                    commercialInvoiceId: budget.commercialInvoiceId,
                    seaFreight: `${budget?.currency?.currency_symbol || ''} ${budget.seaFreight || ''}`,
                    clearingAgencyCharge: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.clearingAgencyCharge || ''}`,
                    freightForwardAgencyCharge: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.freightForwardAgencyCharge || ''}`,
                    cfsLocalCharges: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.cfsLocalCharges || ''}`,
                    shippingLineCharges: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.shippingLineCharges || ''}`,
                    blCharges: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.blCharges || ''}`,
                    othersCharges: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.othersCharges || ''}`,
                    dutyCharge: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.dutyCharge || ''}`,
                    taxCharge: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.taxCharge || ''}`,
                    transportCharge: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.transportCharge || ''}`,
                    conversionRate: budget.conversionRate,
                    createdAt: companyDateFormat(budget.createdAt),
                    updatedAt: companyDateFormat(budget.updatedAt),
                    baseCurrencyName: budget?.baseCurrency?.name || '',
                    currencyName: budget?.currency?.currency_name || '',
                    proformaInvoiceNo: budget?.ProformaInvExp?.proformaInvoiceNo || '',
                    proformaInvExp: budget?.ProformaInvExp || null,
                    commercialInvoice: budget?.CommercialInvoice || null,
                    commercialInvExp: budget?.CommercialInvExp || null,
                }));
                setData(planningBudgetData);
            } else {
                setError('No planning budgets found');
            }
        } catch (error) {
            setError('Error fetching planning budgets');
            console.error('Error fetching planning budgets', error);
        } finally {
            setLoading(false);
        }
    };

    if (!shipmentDetails) {
        return <p> <CustomLoader open={shipmentLoading} /> </p>;
    }

    const handleDelete = async (planningBudgetId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_IMPORT_PLANNING_BUDGET(planningBudgetId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                setDeleteAlert(false);
                fetchButtonList();
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };

    const getCommonData = async () => {
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
    }

    const handleOpen = () => {
        setLeadModal(true);
    };

    const handleClose = () => {
        setLeadModal(false);
    };


    const handleUpdateClick = (id) => {
        setplanningBudgetId(id);
        setUpdateModal(true);
    };


    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setplanningBudgetId('');
    };

    const handleViewClick = (id) => {
        setplanningBudgetId(id);
        setViewModal(true);
    };

    const handleCloseView = () => {
        setViewModal(false);
        setplanningBudgetId('');
    };



    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }

    const ShippingBookingCardColumns = [
        {
            accessor: 'index', label: 'SN', id: 'index', styleAccessor: {
                textAlign: 'center', maxWidth: '200px', width: "50px"
            },
        },
        {
            accessor: 'shipmentId', label: 'Shipment ID', id: 'shipmentId', styleAccessor: {
                textAlign: 'center'
            },
        },
        {
            accessor: 'proformaInvoiceNo', label: 'proforma Invoice', id: 'shipmentId', styleAccessor: {
                textAlign: 'center'
            },
        }, {
            accessor: 'seaFreight',
            label: 'Sea Freight',
            id: 'seaFreight',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'clearingAgencyCharge',
            label: 'Clearing Agency Charge',
            id: 'clearingAgencyCharge',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'freightForwardAgencyCharge',
            label: 'Freight Forward Agency',
            id: 'freightForwardAgencyCharge',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'cfsLocalCharges',
            label: 'CFS Local Charges',
            id: 'cfsLocalCharges',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'shippingLineCharges',
            label: 'Shipping Line Charges',
            id: 'shippingLineCharges',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'blCharges',
            label: 'BL Charges',
            id: 'blCharges',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'othersCharges',
            label: 'Other Charges',
            id: 'othersCharges',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'dutyCharge',
            label: 'Duty Charge',
            id: 'dutyCharge',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'taxCharge',
            label: 'Tax Charge',
            id: 'taxCharge',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'transportCharge',
            label: 'Transport Charge',
            id: 'transportCharge',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'conversionRate',
            label: 'Conversion Rate',
            id: 'conversionRate',
            styleAccessor: { textAlign: 'right' },
        },

        {
            id: 'action',
            label: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                    <IconButton onClick={() => handleViewClick(row.planningBudgetId)} style={{ marginRight: '1px' }}>
                        <VisibilityIcon style={{ color: '#059212' }} />
                    </IconButton>
                    <IconButton onClick={() => handleUpdateClick(row.planningBudgetId)} style={{ marginRight: '1px' }}>
                        <ModeEditOutlineOutlinedIcon style={{ color: '#050C9C' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenDeleteAlert(row.planningBudgetId)}>
                        <DeleteOutlineOutlinedIcon style={{ color: '#E4003A' }} />
                    </IconButton>
                </div>
            ),
        },
    ];

    const companyName = shipmentDetails.customer.clientCompanyName;
    const phoneNumber = shipmentDetails.customer.mobile;
    const cifFobId = shipmentDetails.cifFobId;
    const customerName = shipmentDetails.customerId;
    const shipmentId = shipmentDetails.shipmentId;
    const currencySymbol = shipmentDetails?.company?.baseCurrencyData?.currency_symbol ?? '';
    const baseCurrencyId = shipmentDetails?.company?.baseCurrencyData?.id ?? '';
    const currencyId = shipmentDetails.currencyId;
    const currencySym = shipmentDetails?.currency?.currency_symbol ?? '';
    const shipmentOrgId = shipmentDetails.exportShipmentId;
    const portOfLoading = shipmentDetails.portOfLoading ?? "";
    const portOfDestination = shipmentDetails.portOfDestination ?? "";

    return (
        <div>

            <CustomLoader open={loading} />
            <DetailsPageCard
                Icon={BookOnlineOutlinedIcon}
                columns={ShippingBookingCardColumns}
                title={'Planning & Budget'}
                buttonTitle={'Create Planning & Budget'}
                handleOpen={handleOpen}
                data={data}
                loading={loading}
                error={error}
            />
            <CustomModal open={leadModal}  >
                <CreatePlanningBudgetExport
                    fetchData={fetchData}
                    clientCompanyId={customerName}
                    shipmentId={shipmentId}
                    commanShipmentId={getCommanExportShipmentId}
                    currencyList={currencyList}
                    currencyId={currencyId}
                    currencySym={currencySym}
                    currencySymbol={currencySymbol}
                    baseCurrencyId={baseCurrencyId}
                    shipmentOrgId={shipmentOrgId}
                    setMessage={setMessage}
                    handleClose={handleClose}
                    fetchButtonList={fetchButtonList}
                    proformaInvoiceList={proformaInvoiceList}
                    commercialInvoiceList={commercialInvoiceList}
                />
            </CustomModal>

            <CustomModal open={updateModal}  >
                <UpdatePlanningBudgetExport
                    fetchData={fetchData}
                    setMessage={setMessage}
                    handleClose={handleCloseUpdate}
                    planningBudgetId={planningBudgetId}
                    clientCompanyId={customerName}
                    currencyList={currencyList}
                    proformaInvoiceList={proformaInvoiceList}
                    commercialInvoiceList={commercialInvoiceList}
                />
            </CustomModal>

            <CustomModal
                modalStyles={{
                    maxHeight: '70vh',
                    top: "10%",
                }}
                open={viewModal} handleClose={handleCloseView}>
                <PlanningBudgetExportView
                    fetchData={fetchData}
                    setMessage={setMessage}
                    handleClose={handleCloseView}
                    planningBudgetId={planningBudgetId}
                    clientCompanyId={customerName}
                    currencyList={currencyList}
                />
            </CustomModal>
            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </div>
    );
}
